export default "__VITE_ASSET__DZjmoLRd__"